export default __webpack_public_path__ + "static/solutions-link-icon1.url-dfe64170cfd7d78500d63a8aa750d325.svg";